import React from "react";
import "./Header.css";

const Header = (props) => {
  const handleOnClick = (step, item) => {
    props.setAnswer(step - 1, item);
    props.setStep(step - 1);
  }

  return (
    <header className="header">
      <span onClick={() => handleOnClick(props.step, '')} style={{cursor: 'pointer'}}>{'<'} 뒤로</span>
      <span style={{cursor: 'pointer'}}>닫기</span>
    </header>
  );
}

export default Header;